<template>
  <div>
    <div id="preloader">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <div id="layout-wrapper">
      <NavBar />
      <SideBar
        v-if="!isDriver"
        :is-condensed="isMenuClosed"
        :type="leftSidebarType"
        :width="layoutWidth"
        :bannerExpand="getAsset('banner', 'sidebarMaximize')"
        :bannerCollapse="getAsset('banner', 'sidebarMinimize')"
      />
      <!-- ============================================================== -->
      <!-- Start Page Content here -->
      <!-- ============================================================== -->

      <div
        class="main-content"
        :style="{
          marginRight:
            $store.state.sidebar.notifSideBarOpen && hasAccess(['e4a-alert-center-main:read'])
              ? '420px'
              : '0px',
        }"
      >
        <div
          :class="`page-content${
            $route.path === '/liveview/' || $route.path === '/liveview'
              ? '  mc-page-content--liveview'
              : ''
          }`"
        >
          <AlertRulesUpdateNotice />
          <slot name="header-container" />
          <!-- Start Content-->
          <div class="page-content-inner">
            <slot />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="$route.path !== '/liveview/' && $route.path !== '/liveview'"
      class="d-flex justify-content-between mc-menu-mobile"
    >
      <span @click="$router.push({ name: 'Dashboard' })">
        <i class="mc-fa icon-outline_browser"></i>
        <p>{{ $t('menuitems.dashboards.text') }}</p>
      </span>

      <span @click="$router.push({ name: 'Liveview' })">
        <i class="mc-fa icon-outline_car"></i>
        <p>{{ $t('menuitems.liveView.text') }}</p>
      </span>

      <span @click="$router.push({ name: 'Notifikasi' })">
        <i class="mc-fa icon-outline_bell"></i>
        <p>{{ $t('menuitems.notifikasi.text') }}</p>
      </span>

      <span @click="$router.push({ name: 'Report' })">
        <i class="mc-fa icon-outline_book"></i>
        <p>{{ $t('menuitems.laporan.text') }}</p>
      </span>
    </div>
    <b-modal
      id="modal-banner"
      ref="modal-banner"
      title=""
      size="lg"
      centered
      hide-footer
      hide-header
      modal-class="mc-modal-banner"
      :hidden="!getAsset('banner', 'popup')"
    >
      <div class="mc-modal-banner__wrapper">
        <a
          v-if="getAsset('bannerDirect', 'general')"
          :href="getAsset('bannerDirect', 'general')"
          target="_blank"
          @click="mixpanelBanner"
        >
          <img :src="getAsset('banner', 'popup')" alt="banner" />
        </a>
        <img v-else :src="getAsset('banner', 'popup')" alt="banner" />
        <i class="mc-fa icon-outline_close" @click="hideModalBanner"></i>
        <!-- Code will be used if need button -->
        <!-- <a :href="bannerLink" class="mc-btn btn btn-success" target="_blank"
            ><i class="mc-fa icon-outline_whatsapp"></i> Kontak Kami</a
          > -->
      </div>
    </b-modal>

    <b-modal
      v-if="!feedbackStatus"
      id="modal-feedback"
      ref="modal-feedback"
      title="VSMS Feedback"
      size="lg"
      centered
      hide-footer
      modal-class="mc-modal-feedback"
      @hide="hideModalFeedback"
    >
      <div class="mc-modal-feedback">
        <div class="h5">Seberapa puas Anda menggunakan VSMS ?</div>
        <div class="d-flex justify-content-around my-3">
          <div class="col-md-2 text-center">
            <label>
              <p class="text-center">Sangat Tidak Puas</p>
              <input type="radio" name="point" :value="1" v-model="feedback.point" />
              <img src="@/assets/images/feedback/CSAT1.svg" alt="1" class="mt-sm-n1" />
            </label>
          </div>
          <div class="col-md-2 text-center">
            <label>
              <p class="text-center">Tidak Puas</p>
              <input type="radio" name="point" :value="2" v-model="feedback.point" />
              <img
                src="@/assets/images/feedback/CSAT2.svg"
                alt="1"
                class="mt-lg-0 mt-md-3 mt-sm-3 mt-sm-auto"
              />
            </label>
          </div>
          <div class="col-md-2 text-center">
            <label>
              <p class="text-center">Netral</p>
              <input type="radio" name="point" :value="3" v-model="feedback.point" />
              <img
                src="@/assets/images/feedback/CSAT3.svg"
                alt="1"
                class="mt-lg-0 mt-md-3 mt-sm-3 mt-sm-auto"
              />
            </label>
          </div>
          <div class="col-md-2 text-center">
            <label>
              <p class="text-center">Puas</p>
              <input type="radio" name="point" :value="4" v-model="feedback.point" />
              <img
                src="@/assets/images/feedback/CSAT4.svg"
                alt="1"
                class="mt-lg-0 mt-md-3 mt-sm-3 mt-sm-auto"
              />
            </label>
          </div>
          <div class="col-md-2 text-center">
            <label>
              <p class="text-center">Sangat Puas</p>
              <input type="radio" name="point" :value="5" v-model="feedback.point" />
              <img
                src="@/assets/images/feedback/CSAT5.svg"
                alt="1"
                class="mt-lg-0 mt-md-3 mt-sm-3 mt-sm-auto"
              />
            </label>
          </div>
        </div>
        <div class="h5">
          Apakah ada issue, masukan maupun permintaan fitur yang Anda ingin bagikan kepada kami ?
        </div>
        <div class="d-flex rounded-2">
          <textarea
            name=""
            class="rounded-2 p-2 mc-feedback-line-height"
            cols="100"
            rows="10"
            v-model="feedback.comment"
            placeholder="Masukkan tanggapan Anda mengenai VSMS"
          ></textarea>
        </div>
        <div class="d-flex gap-2 justify-content-end mt-3">
          <div class="">
            <b-button id="" type="button" variant="outline-primary" @click="hideModalFeedback">
              Batal
            </b-button>
          </div>
          <div class="">
            <b-button id="" type="button" variant="primary" @click="submitFeedback">
              Simpan
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import NavBar from './NavBar'
import SideBar from './SideBar'
import AlertRulesUpdateNotice from './AlertRulesUpdateNotice'
import * as feedbackApi from '@/services/rest-api-vsms/lib/feedback/feedback'
import Swal from 'sweetalert2'
import { MixPanel } from '@/mixin/mixpanel'
import * as bannerApi from '@/services/rest-api-vsms/lib/banner/banner'
/**
 * Vertical layout
 */
export default {
  components: { NavBar, SideBar, AlertRulesUpdateNotice },
  mixins: [MixPanel],
  data() {
    return {
      type: this.$store ? this.$store.state.layout.leftSidebarType : null,
      width: this.$store ? this.$store.state.layout.layoutWidth : null || null,
      bannerLink: process.env.VUE_APP_BANNER_URL,
      bannerImage: process.env.VUE_APP_BANNER_IMAGE_URL,
      bannerExpand: process.env.VUE_APP_BANNER_SIDEBAR_EXPAND_URL,
      bannerCollapse: process.env.VUE_APP_BANNER_SIDEBAR_COLLAPSE_URL,
      feedbackStatus: false,
      feedbackSubtractDay: parseInt(process.env.VUE_APP_FEEDBACK_SUBTRACT_DAY) || 0,
      feedback: {
        point: 5,
        comment: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
      hasAccess: 'identity/hasAccess',
      getAsset: 'asset/getAsset',
      isWhitelabel: 'identity/isWhitelabel',
      isMetrack: 'identity/isMetrack',
    }),
    ...mapState('layout', [
      'layoutType',
      'layoutWidth',
      'leftSidebarType',
      'topbar',
      'loader',
      'isMenuClosed',
    ]),

    isDriver() {
      return (
        this.hasAccessAll(['tms_driver:read', 'tms_driver:update']) &
        !this.hasAccess(['vgroups:read'])
      )
    },
  },
  created: () => {
    document.body.removeAttribute('data-layout', 'horizontal')
    document.body.removeAttribute('data-topbar', 'dark')
    document.body.removeAttribute('data-layout-size', 'boxed')
    document.body.classList.remove('auth-body-bg')
  },
  mounted() {
    if (this.loader === true) {
      document.getElementById('preloader').style.display = 'block'
      document.getElementById('status').style.display = 'block'

      setTimeout(function () {
        document.getElementById('preloader').style.display = 'none'
        document.getElementById('status').style.display = 'none'
      }, 2500)
    } else {
      document.getElementById('preloader').style.display = 'none'
      document.getElementById('status').style.display = 'none'
    }

    this.checkerModalBannerShow()
    this.checkerModalFeedbackShow()

    if (this.isDriver) {
      this.$store.dispatch('layout/toggleMenu', true)
    } else {
      this.$store.dispatch('layout/toggleMenu', this.isMenuClosed)
    }
  },
  methods: {
    mixpanelBanner() {
      this.track('Click Banner', {
        user_name: this.$store.state.identity.whoami?.name,
        email: this.$store.state.identity.whoami?.email,
        company_name: this.$store.state.identity.whoami?.companyName,
        access_right: this.$store.state.identity.whoami?.accessRight,
      })
    },
    showModalBanner() {
      this.$refs['modal-banner']?.show()
    },
    hideModalBanner() {
      this.$refs['modal-banner']?.hide()
    },
    showModalFeedback() {
      let today = new Date()
      if (localStorage.getItem('expired-feedback') === null) {
        setTimeout(() => {
          this.$refs['modal-feedback']?.show()
        }, 60 * 1000)
        return
      }
      if (today <= new Date(localStorage.getItem('expired-feedback'))) return
      setTimeout(() => {
        this.$refs['modal-feedback']?.show()
      }, 60 * 1000)
    },
    hideModalFeedback() {
      let today = new Date()
      today.setHours(23, 59, 0, 0)
      localStorage.setItem('expired-feedback', today)
      this.$refs['modal-feedback']?.hide()
    },

    toggleMenu() {
      this.$store.dispatch('layout/toggleMenu', !this.isMenuClosed)
    },
    toggleRightSidebar() {
      document.body.classList.toggle('right-bar-enabled')
    },
    hideRightSidebar() {
      document.body.classList.remove('right-bar-enabled')
    },
    async checkerModalFeedbackShow() {
      try {
        const resStatus = await feedbackApi.checkStatus()
        this.feedbackStatus = resStatus.data.status
      } catch (error) {
        this.feedbackStatus = true
      }
      const dayNow = new Date().getDate()
      const dayEnd = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate()

      if (this.isWhitelabel() || this.isMetrack()) {
        this.feedbackStatus = true
      }

      if (this.feedbackStatus) return
      if (process.env.NODE_ENV !== 'production') this.showModalFeedback()
      if (dayEnd - this.feedbackSubtractDay <= dayNow && dayNow <= dayEnd) this.showModalFeedback()
    },
    async checkerModalBannerShow() {
      const currentRouteName = this.$route.name
      if (currentRouteName !== 'Dashboard') return

      const isJustLoggedIn = this.$route.query.isLoginSuccess
      if (!isJustLoggedIn) return

      const today = new Date().getDay() - 1
      const bannerShowDays = true
        ? await this.getBannersDayShow()
        : process.env.VUE_APP_BANNER_SHOW

      if (!bannerShowDays) return

      const showBannerOnDays = Array.isArray(bannerShowDays)
        ? bannerShowDays.map((day) => day.toString())
        : bannerShowDays.split(',')

      if (showBannerOnDays.includes(today.toString())) {
        this.showModalBanner()
      }
    },

    async getBannersDayShow() {
      const requestParams = {
        domain: window.location.hostname,
      }

      const response = true
        ? await bannerApi.get(requestParams)
        : await bannerApi.getBanners()

      if (response.data) {
        return true
          ? response.data[0].day_show
          : response.data.day_show
      }
    },
    async submitFeedback() {
      const createdData = await feedbackApi.store(this.feedback)
      if (!createdData) return false
      this.$refs['modal-feedback']?.hide()
      await Swal.fire({
        title: 'Terima Kasih!',
        text: this.$t('feedback.text.postSubmitFeedback'),
        imageUrl: require(`@/assets/images/success-icon.png`),
        showConfirmButton: false,
        width: '32em',
        height: 'auto',
        padding: '0 0 2em',
        customClass: {
          htmlContainer: 'mc-feedback-line-height',
        },
      })
    },
  },
}
</script>

<style scoped>
[type='radio'] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
[type='radio'] + img {
  cursor: pointer;
  filter: grayscale(1);
}
[type='radio']:checked + img {
  filter: grayscale(0);
}
</style>
